import * as React from 'react';
import { useSelector } from 'react-redux';
import { CallbackButton } from '../../components/CallbackButton';
import { selectGaLabel } from '../../selectors/analytics';
import { trackCallbackPopupOpen } from '../../utils/analytics';
import { CallbackPopupContainer } from '../CallbackPopup';

export const CallbackButtonContainer: React.VFC = () => {
  const [isPopupOpen, setPopupOpen] = React.useState(false);
  const customPageUrl = useSelector(selectGaLabel);

  const openCallbackWidget = React.useCallback(() => {
    setPopupOpen(true);
    trackCallbackPopupOpen(customPageUrl);
  }, [customPageUrl]);

  const closeCallbackWidget = React.useCallback(() => {
    setPopupOpen(false);
  }, []);

  return (
    <>
      <CallbackButton onClick={openCallbackWidget} />
      <CallbackPopupContainer open={isPopupOpen} onClose={closeCallbackWidget} />
    </>
  );
};
